import { render, staticRenderFns } from "./ReturnView.vue?vue&type=template&id=e22d0550&scoped=true&"
import script from "./ReturnView.vue?vue&type=script&lang=js&"
export * from "./ReturnView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnView.vue?vue&type=style&index=0&id=e22d0550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22d0550",
  null
  
)

export default component.exports